
import DescriptionView from './DescriptionView/DescriptionView'
import {useSinglePlanBT } from '../../../../hooks'
import {  dateConverter } from '../../../../../../common/utils/dateConverter'
import { useSingleMinigrid } from '../../../../../minigrid/hook'


export default function DescriptionPresenter() {
    const {singlePlanBTQuery:{data, isLoading}} = useSinglePlanBT()
    const {singleMinigridQuery } = useSingleMinigrid(data?.plan_minigrid|| undefined)
    if(isLoading) return <p>Loading...</p>

    const createAt = data?.plan_created_at
    ? dateConverter(data?.plan_created_at)
    : undefined;

  const updatedAt = data?.plan_updated_at
    ? dateConverter(data?.plan_updated_at)
    : undefined;


  return (
    <DescriptionView title='Description' text={data?.plan_description } title2='Minigird' text2={ singleMinigridQuery.data?.minigrid_name} createdAt={createAt} updatedAt={updatedAt}/>
  )
}


